import React, { useState, useEffect, useRef } from "react";
import {
    Card, CardContent, CircularProgress, IconButton, CardMedia, Button, Box, Badge,
    TextField,
    InputAdornment,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Paper,
    Typography
} from '@mui/material';
import '../css/App.css';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { isBrowser, isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import ImageIcon from "@mui/icons-material/Image";
import SD1 from '../assets/search_dropdown/laptop_SD1.jpeg';
import SD2 from '../assets/search_dropdown/laptop_stand_SD2.jpg';
import SD3 from '../assets/search_dropdown/gaming_laptop_SD3.jpeg';
import SD4 from '../assets/search_dropdown/ultrabook_laptop_SD4.jpeg';
import SD5 from '../assets/search_dropdown/cooling_pad_SD5.jpeg';
import SD6 from '../assets/search_dropdown/tablet_SD6.jpeg';
import SD7 from '../assets/search_dropdown/wireless_earbuds_SD7.jpeg';
import SD8 from '../assets/search_dropdown/bluetooth_speakers_SD8.jpeg';
import SD9 from '../assets/search_dropdown/smart_watch_SD9.jpeg';
import SD10 from '../assets/search_dropdown/fitness_tracker_SD10.jpeg';
import SD11 from '../assets/search_dropdown/smartphone_SD11.jpeg';
import SD12 from '../assets/search_dropdown/androidmobiles_SD12.jpeg';
import SD13 from '../assets/search_dropdown/iphone_SD13.jpeg';
import SD14 from '../assets/search_dropdown/mobilebackcovers_SD14.jpeg';
import SD15 from '../assets/search_dropdown/screenprotectors_SD15.jpeg';
import CloseIcon from "@mui/icons-material/Close";

type Suggestion = {
    label: string;
    image: string | null;
};

const dummySuggestions: Suggestion[] = [
    // Electronics & Gadgets
    { label: "laptop", image: SD1 },
    { label: "laptop stand", image: SD2 },
    { label: "gaming laptop", image: SD3 },
    { label: "ultrabook laptops", image: SD4 },
    { label: "laptop cooling pad", image: SD5 },
    { label: "tablet", image: SD6 },
    { label: "wireless earbuds", image: SD7 },
    { label: "Bluetooth speakers", image: SD8 },
    { label: "smartwatch", image: SD9 },
    { label: "fitness tracker", image: SD10 },

    // Mobile Phones
    { label: "smartphones", image: SD11 },
    { label: "android mobiles", image: SD12 },
    { label: "iPhone", image: SD13 },
    { label: "mobile back covers", image: SD14 },
    { label: "screen protectors", image: SD15 },
    { label: "mobile tripods", image: null },
    { label: "wireless chargers", image: null },
    { label: "fast charging cables", image: null },

    // LED TVs
    { label: "smart LED TV", image: null },
    { label: "4K Ultra HD TV", image: null },
    { label: "Android TV", image: null },
    { label: "TV wall mount", image: null },
    { label: "LED TV under 20000", image: null },

    // Home Essentials
    { label: "electric kettles", image: null },
    { label: "air purifiers", image: null },
    { label: "water heaters", image: null },
    { label: "blenders and mixers", image: null },
    { label: "home cleaning kits", image: null },
    { label: "storage containers", image: null },
    { label: "LED emergency lights", image: null },
    { label: "extension cords", image: null },

    // common queries
    { label: "Which is the best budget smartphone in 2025?", image: null },
    { label: "Top 5 laptops for students under ₹50000", image: SD1 },
    { label: "How to choose the right screen size for LED TV?", image: null },
    { label: "Which smart home gadgets are trending now?", image: null },
];


const Header = () => {

    const navigate = useNavigate();
    const [input, setInput] = useState("");
    const [filtered, setFiltered] = useState<Suggestion[]>([]);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (input.trim()) {
            const results = dummySuggestions.filter((item) =>
                item.label.toLowerCase().includes(input.toLowerCase())
            );
            setFiltered(results);
        } else {
            setFiltered([]);
        }
    }, [input]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setFiltered([]); // Close dropdown
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            {/* header section */}
            <Box className="home-header-box">
                <Typography className="header-typo" sx={{ fontWeight: 900, fontSize: '30px', cursor: 'pointer' }} onClick={() => navigate('/')}>Fortune Five</Typography>

                <Box className="header-icon-box">

                    <div className="search-bar-container">

                        {/* browser deliver to */}
                        {!isMobile ? <div className="deliver-box">
                            <LocationOnIcon className="location-icon" />
                            <div className="deliver-text">
                                <div className="deliver-label">Deliver to</div>
                                <div className="deliver-country">Berlin</div>
                            </div>
                        </div> : <></>}
                        {/* deliver to end */}

                        {/* Search field */}
                        {/*  <div className="search-bar-wrapper" style={{ width: isMobile ? '100%' : '50vw', maxWidth: '900px' }}>
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Search FortuneFive Products"
                            />
                            <button className="search-button">
                                <SearchIcon />
                            </button>
                        </div> */}
                        <Box sx={{ width: { xs: "100%", md: "50vw" }, maxWidth: 900, position: "relative" }}>
                            <TextField
                                fullWidth
                                placeholder="Search FortuneFive Products"
                                variant="outlined"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                sx={{
                                    backgroundColor: 'white',
                                    borderRadius: 1,
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#C32032',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#C32032',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#C32032',
                                        },
                                        color: '#C32032', // text color
                                    },
                                    '& .MuiInputBase-input::placeholder': {
                                        color: '#C32032',
                                        opacity: 1, // ensure visibility
                                    },
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {input && (
                                                <IconButton onClick={() => {
                                                    setInput("");
                                                    setFiltered([]);
                                                    navigate("/products", { state: { searchTerm: "" } }); // reset view
                                                }}>
                                                    <CloseIcon sx={{ color: '#C32032' }} />
                                                </IconButton>
                                            )}
                                            <SearchIcon sx={{ color: '#C32032', ml: input ? 1 : 0 }} />
                                        </InputAdornment>
                                    ),
                                }}
                                /* InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon sx={{ color: '#C32032' }} />
                                        </InputAdornment>
                                    ),
                                }} */
                                inputProps={{
                                    style: { color: '#C32032' },
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && input.trim()) {
                                        navigate("/products", { state: { searchTerm: input } });
                                        setInput("");
                                        setFiltered([]);
                                    }
                                }}
                            />

                            {filtered.length > 0 && (
                                <Paper
                                    ref={dropdownRef}
                                    elevation={3}
                                    sx={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        zIndex: 10,
                                        maxHeight: 300,
                                        overflowY: "auto",
                                    }}
                                >
                                    <List>
                                        {filtered.map((item, index) => (
                                            <ListItem
                                                key={index}
                                                // button
                                                // onClick={() => setInput(item.label)}
                                                onClick={() => {
                                                    navigate("/products", { state: { searchTerm: item.label } });
                                                    setInput(item.label);
                                                    setFiltered([]);
                                                }}
                                                component="div"
                                            >
                                                <ListItemIcon>
                                                    {item.image ? (
                                                        <img
                                                            src={item.image}
                                                            alt=""
                                                            style={{ width: 30, height: 30, borderRadius: 4 }}
                                                        />
                                                    ) : (
                                                        <ImageIcon />
                                                    )}
                                                </ListItemIcon>
                                                <ListItemText primary={item.label} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Paper>
                            )}
                        </Box>
                        {/* search field end */}

                    </div>


                    <IconButton>
                        <NotificationsIcon className="header-icons" />
                    </IconButton>
                    <IconButton onClick={() => navigate('/cart')}>
                        <Badge badgeContent={/* window.location.pathname === '/order-placed' || window.location.pathname === '/my-account' ? */ 0/*  : 2 */} color="success">
                            <ShoppingCartIcon className="header-icons" />
                        </Badge>
                    </IconButton>

                    {/* displaying signin or signup option from account icon's hover */}
                    <Box className="account-dropdown-container">
                        <IconButton>
                            <AccountCircleIcon className="header-icons" />
                        </IconButton>

                        <Box className="account-dropdown">
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#C32032',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    mb: 1,
                                    '&:hover': {
                                        backgroundColor: '#C32032',
                                    },
                                }}
                                fullWidth
                                // onClick={() => navigate('/signin')}
                                onClick={() => navigate('/my-account')}
                            >
                                {/* Sign in */}My Account
                            </Button>
                            {/* <Typography variant="body2" sx={{ textAlign: 'center' }}>
                                New customer? <a href="/signup" style={{ color: '#C32032' }}>Start here.</a>
                            </Typography> */}
                        </Box>
                    </Box>
                    {/* end */}

                </Box>
            </Box>
            {/* End header section */}
        </>
    );
}

export default Header;